/**
 * Тексты системных писем — русский (основной язык сервиса).
 *
 * Все строки писем собраны в одном модуле, чтобы позже подключить i18n без
 * правки шаблонов: достаточно добавить второй набор ключей по локали и
 * резолвер. Сейчас локаль не резолвится намеренно — пер-юзерной локали в
 * сервисе нет (`src/i18n/routing.ts` работает от URL), поэтому все письма
 * всегда русские (решение по задаче t_d176ce73 от 2026-09-18).
 */

export const emailCopy = {
	/** Бренд — не переводится. */
	brand: "forms.projme",

	/** Общий футер всех писем (emails/components/email-layout.tsx). */
	footer: "forms.projme — формы корпоративного уровня по честной цене.",
	/** Fallback, если в письмо не передан markdown-контент. */
	noContent: "Содержимое не передано.",

	cta: {
		dashboard: "Перейти в дашборд",
		analytics: "Смотреть аналитику формы",
	},

	welcome: {
		subject: "Добро пожаловать в forms.projme! 🎉",
		heading: "Добро пожаловать в forms.projme! 🎉",
		preview: "Создавайте формы, собирайте ответы и анализируйте данные.",
		greeting: (name?: string) =>
			`Здравствуйте${name ? `, ${name}` : ""}! Мы рады, что вы с нами.`,
		body: "Создайте первую форму за пару минут и сразу начните собирать ответы.",
	},

	newLogin: {
		subject: "Новый вход в ваш аккаунт forms.projme",
		heading: "Новый вход в forms.projme",
		preview: "Если это были не вы, смените пароль.",
		body: (name?: string) =>
			`Мы зафиксировали новый вход в ваш аккаунт forms.projme${
				name ? `, ${name}` : ""
			}. Если это были вы, письмо можно проигнорировать.`,
		/** Ящик no-reply — ответить на него нельзя, поэтому обратной связи не обещаем. */
		warning:
			"Если это были не вы, немедленно смените пароль в настройках аккаунта.",
	},

	premiumThanks: {
		subject: "Спасибо за покупку! 🎉",
		heading: "Спасибо за покупку! 🎉",
		preview: "Вам доступны все премиум-возможности.",
		thanks: (name?: string) =>
			`Спасибо${name ? `, ${name},` : ""} за покупку forms.projme Premium! Вам доступны все премиум-возможности.`,
		body: "Безлимитные отправки, расширенная аналитика, экспорт, интеграции и многое другое.",
	},

	/** Дефолты уведомления владельцу формы о новой отправке. */
	formNotification: {
		defaultSubject: "Вы получили новую отправку! 🥳",
		defaultMessage: "Ура!! Вы получили новую отправку на свою форму.",
		fallbackSubject: (formTitle: string) => `Новая отправка: ${formTitle}`,
		fallbackMessage: (formTitle: string) =>
			`Вы получили новую отправку на свою форму: ${formTitle}.`,
	},
} as const;
